import React, { useState } from "react"
import { NavigationDataItem } from "../../utils/extract-navigation"

import MenuItem from "./menu-item"

export interface MenuProps {
  navigationData: NavigationDataItem[]
  navigationSecondaryData: NavigationDataItem[]
  darkButton?: boolean
}

const Menu: React.FC<MenuProps> = props => {
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const toggleMenu = (e: React.MouseEvent) => {
    ;(e.target as HTMLElement).blur()
    if (menuIsOpen) {
      setMenuIsOpen(false)
      document.body.classList.remove("-menu-overlay-visible")
    } else {
      setMenuIsOpen(true)
      document.body.classList.add("-menu-overlay-visible")
    }
  }

  return (
    <section className="c-menu">
      <nav className="c-menu__full">
        <ul></ul>
        <button
          id="c-menu__hamburger-menu"
          className={`c-menu__hamburger-menu has-pointer ${
            props.darkButton ? "-dark" : ""
          }`}
          aria-controls="top-menu-wrapper"
          aria-expanded={menuIsOpen}
          onClick={toggleMenu}
        >
          <span></span>
          <span></span>

          <div className="is-visually-hidden">Toggle menu</div>
        </button>
      </nav>
      <div
        id="c-menu__top-menu-wrapper"
        className="c-menu__top-menu-wrapper"
        aria-labelledby="top-hamburger-menu"
        aria-hidden={!menuIsOpen}
      >
        <div className="c-menu__top-menu-wrapper__inner o-wrapper u-flex u-relative">
          <a className="c-logo o-row"></a>
          <div className="c-menu__top-menu-wrapper__inner__menu u-flex">
            <nav className="c-menu__items -topnav u-flex u-flex-column">
              {props.navigationData.map(item => {
                return (
                  <MenuItem
                    key={item.key}
                    item={item}
                    clickCallback={toggleMenu}
                  />
                )
              })}
            </nav>
            <nav className="c-menu__items -subnav u-flex u-flex-column">
              {props.navigationSecondaryData.map(item => {
                return (
                  <MenuItem
                    key={item.key}
                    item={item}
                    clickCallback={toggleMenu}
                  />
                )
              })}
            </nav>
          </div>
        </div>

        <div className="o-wrapper">
          <div className="c-menu__bottom u-flex u-space-between">
            <address className="c-menu__bottom__address u-flex">
              <div>
                <div>
                  Northvolt AB ⌁ Alströmergatan 22 <br />
                </div>
                <div>SE-112 47, Stockholm, Sweden</div>
              </div>
              <a className="c-link -light" href="mailto:hi@northvolt.com">
                hi@northvolt.com
              </a>
            </address>

            <div className="u-flex c-menu__bottom__social">
              <a href="https://twitter.com/northvolt" className="twitter"></a>
              <a
                href="https://www.facebook.com/Northvolt/"
                className="facebook"
              ></a>
              <a
                href="https://www.linkedin.com/company/northvolt"
                className="linkedin"
              ></a>
              <a
                href="https://www.instagram.com/northvolt/"
                className="instagram"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Menu
